import { useAuth0 } from '@auth0/auth0-react';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { images } from '../../assets/images';
import { BellSvg } from '../../assets/svg-icon-components/BellSvg';
import { LOGOUT_ACTION_SESSION_CODE_PARAM } from '../../model/store';
import { RhButton, RhButtonMode } from './RhButton';
import { RhDropdown } from './RhDropdown';
import { useRequest } from '../../util/use-request';
import { RhRawButton } from './RhRawButton';
import { colors, H5 } from './Styles';
import { apiConfigs } from '../../api/APIConfigs';
import { Church } from '../../api/models/Church';

export const Header: React.FC<{}> = () => {
  const { user, logout, getAccessTokenSilently } = useAuth0();
  const request = useRequest();
  const [churchName, setChurchName] = useState<string>('');

  const loadChurches = useCallback(async () => {
    try {
      let userObject = JSON.parse(JSON.stringify(user));
      console.log('USER OBJECT:', userObject);
      let churchKey: string = userObject['https:///churchkey']; //'CHURCHKEY.RISENHOPE';
      let churchId: string = userObject['https:///churchid']; //'b26dd9a5-659e-4947-8ae2-76d553d9655f';

      const token = await getAccessTokenSilently();
      console.log('API TOKEN:', token);
      const result = await request<Church>(apiConfigs.getChurchById(churchId));
      let church = result;

      if (church != null) {
        setChurchName(church.name);
      } else {
        let churchNameSplit = churchKey.split('.');
        let churchFilter = churchNameSplit.length > 1 ? churchNameSplit[1] : churchNameSplit[0];
        setChurchName(churchFilter);
      }
    } catch (e) {
      setChurchName('SYSADMIN');
    }
  }, [request]);

  useEffect(() => {
    loadChurches();
  }, [loadChurches]);

  return (
    <Container>
      <Flexed>
        <Logo src={images.risenHopeLogo} />
      </Flexed>
      <Flexed>
        {/* Implement once API supports notification */}
        {/* <NotificationDiv>
          <BellSvg width={20} height={20} />
          <Tick>1</Tick>
        </NotificationDiv> */}
        <Border>
          <H5>
            <ChurchBadge>{churchName}</ChurchBadge>Hi, {_.startCase(user?.nickname || '').split(' ')[0] || 'user'}!
          </H5>
          <RhDropdown trigger={<Image src={user?.picture} />}>
            <RhButton
              mode={RhButtonMode.text}
              title="Log out"
              onClick={() => {
                const returnTo = `${window.location.origin}?session=${LOGOUT_ACTION_SESSION_CODE_PARAM}`;
                logout({ returnTo });
              }}
            />
          </RhDropdown>
        </Border>
      </Flexed>
    </Container>
  );
};

const ChurchBadge = styled.span`
  color: #fff;
  background-color: #17a2b8;
  padding-right: 0.6em;
  padding-left: 0.6em;
  padding-top: 0.2em;
  margin: 5px;
  padding-bottom: 0.2em;
  border-radius: 10rem;
`;

const Container = styled.div`
  height: 80px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #e2e7ea;
`;

const Flexed = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const Border = styled.div`
  margin-left: 30px;
  display: flex;
  align-items: center;
  padding: 8px;

  & > :not(:last-child) {
    margin-right: 18px;
  }
`;

const Logo = styled.img`
  width: 200px;
  height: auto;
  object-fit: contain;
  margin-left: -10px;
`;

const Image = styled.img`
  height: 48px;
  width: 48px;
  border-radius: 24px;
`;

const NotificationDiv = styled(RhRawButton)`
  position: relative;
`;

const Tick = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  font-weight: bold;
  font-size: 10px;
  letter-spacing: 0.035em;
  color: #ffffff;
  background-color: ${colors.primary};
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
`;
